<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
              <Form-item label="自增ID" prop="id">
                <Input type="text" v-model="searchForm.id" placeholder="请输入自增ID" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="预警类型" prop="type">
                <Input type="text" v-model="searchForm.type" placeholder="请输入预警类型" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="第三方业务id" prop="thirdTransactionId">
                  <Input type="text" v-model="searchForm.thirdTransactionId" placeholder="请输入第三方业务id" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="用户id" prop="registerId">
                  <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户id" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="用户名称" prop="name">
                  <Input type="text" v-model="searchForm.name" placeholder="请输入用户名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="预警状态" prop="status">
                  <Input type="text" v-model="searchForm.status" placeholder="请输入预警状态" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="是否处理" prop="solveFlag">
                  <Select v-model="searchForm.solveFlag">
                    <Option value="">全部</Option>
                    <Option value="0">未处理</Option>
                    <Option value="1">已处理</Option>
                  </Select>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="solveAll" icon="md-trash">批量处理</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>

    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="自增ID">
          {{form.id}}
        </FormItem>
        <FormItem label="预警类型">
          {{form.type}}
        </FormItem>
        <FormItem label="第三方业务id">
          {{form.thirdTransactionId}}
        </FormItem>
        <FormItem label="预警内容">
          {{form.content}}
        </FormItem>
        <FormItem label="用户id">
          {{form.registerId}}
        </FormItem>
        <FormItem label="用户名称">
          {{form.name}}
        </FormItem>
        <FormItem label="是否处理">
           <span v-if="form.solveFlag==0">未处理</span>
           <span v-if="form.solveFlag==1">已处理</span>
        </FormItem>
        <FormItem label="备注">
          {{form.remarks}}
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
      </div>
    </Modal>

    <Modal :title="modalSolveTitle" v-model="modalSolveVisible" :mask-closable='false' :width="500">
      <Form ref="formSolve" :model="formSolve" :label-width="100" :rules="formSolveValidate" >
        <FormItem label="主键ID" prop="id" style="display:none;">
          <Input v-model="formSolve.id" style="width:100%"/>
        </FormItem>
        <FormItem label="备注" prop="remarks" >
          <textarea v-model="formSolve.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalSolveVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "EarlyWarning",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      modalSolveVisible: false, // 添加或编辑显示
      modalSolveTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "update_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        id: "",
        type: "",
        thirdTransactionId: "",
        content: "",
        registerId: "",
        name: "",
        solveFlag: "",
        status: "",
      },
      formSolve: { // 添加或编辑表单对象初始化数据
        id: "",
        remarks: "",
      },
      // 表单验证规则
      formValidate: {
      },
      // 表单验证规则
      formSolveValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "自增ID",
          key: "id",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预警类型",
          key: "type",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "第三方业务id",
          key: "thirdTransactionId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户id",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户名称",
          key: "name",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "预警状态",
          key: "status",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否处理",
          key: "solveFlag",
          minWidth: 120,
          sortable: false,
          render(h, params){
            let solveFlag = '';
            let style = '';
            if(params.row.solveFlag == '0'){
              solveFlag = '未处理';
            }
            if(params.row.solveFlag == '1'){
              solveFlag = '已处理';
            }
            return h('span', {
              style: style
            }, solveFlag);
          }
        },
        {
          title: "创建时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row);
                    }
                  }
                },
                "详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "预警处理"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
       this.getRequest("/earlyWarning/getByPage", this.searchForm).then(res => {
         this.loading = false;
         if (res.success) {
           this.data = res.result.records;
           this.total = res.result.total;
         }
       });
    },
    handleSubmit() {
      this.$refs.formSolve.validate(valid => {
          this.submitLoading = true;
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          this.formSolve.id = ids
          console.log(ids);
          // 编辑
          this.getRequest("/earlyWarning/solveAllByIds", this.formSolve).then(res => {
           this.submitLoading = false;
           if (res.success) {
             this.$Message.success("操作成功");
             this.modalSolveVisible = false;
             this.clearSelectAll();
             this.getDataList();
           }
          })
      });
    },
    detail(v) {
      this.modalTitle = "详情";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    edit(v) {
      this.$refs.formSolve.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.formSolve.id = data.id;
      this.modalSolveTitle = "预警处理";
      this.modalSolveVisible = true;
    },
    solveAll(){
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要处理的数据");
        return;
      }
      delete this.formSolve.id;
      this.modalSolveTitle = "预警处理";
      this.modalSolveVisible = true;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>